module.exports = __webpack_public_path__ + "static/img/103.3288fb1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/201224/103.jpg
// module id = 6DJ7
// module chunks = 0